export const apiUserRoutes = {
  routeRegisterUser: 'auth/auth/register_web',
  routeGetUser: 'auth/auth/user/',
  routeEditUser: 'auth/auth/edit_user/',
  routeChangePassword: 'auth/auth/change_password/',
  routeGetUsersList: 'auth/auth/listuser',
  routeGetClientList: 'auth/auth/listclient',
  routeEmailExist: 'auth/auth/existemail',
  routePhoneExist: 'auth/auth/existphone',
  routeDeleteUser: 'auth/auth/delete/',
};